import { ISelectModel } from 'common/models';
import API from 'services/api';

export const getAllUnits = (propertyId?: string): Promise<ISelectModel<string>[]> => {
  return API.get(`/api/accommodation/properties/${propertyId}/units/all`).then(
    response => response?.data,
  );
};
